import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MessageService } from 'primeng/api';
import { IDoctor } from 'src/app/shared/interfaces/doctor';
import { IDoctorException } from 'src/app/shared/interfaces/doctorException';
import { IVisitInp } from 'src/app/shared/interfaces/visitInp';
import { EVisitType } from 'src/app/shared/interfaces/visitType-enum';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';
import { DateService } from 'src/app/shared/services/date.service';
import { RedirectCleanupService } from "src/app/shared/services/redirectCleanUp.service";


@Component({
  selector: 'app-doctor-detail',
  templateUrl: './doctor-detail.component.html',
  styleUrl: './doctor-detail.component.css'
})
export class DoctorDetailComponent implements OnInit{

  isAuthenticated: boolean;
  drID: any;
  drDetail: IDoctor;
  calendar: any[] = [];
  visitType = EVisitType;
  visitTypeAndPrice: any;
  exceptionDays: IDoctorException[];
  timeList = [];
  addVisit: IVisitInp = {
    startVisit: 0,
    endVisit: 0,
    counter: 0,
    date: null,
    doctorId: null,
    visitType: null
  };
  takenVisits: any[];
  disabledTimes = [];
  filteredTimeList: any = [];
  selectedDate: any;
  todayDate: any;
  todayDateGregorian: any;

  isVideo:boolean = true;

  realTimes: { [key: string]: number } = {}; // Mapping for time to minutes
  selectedMinutes: number | null = null; // Stores the selected minute value

  @ViewChild('modal') modal!: ModalComponent;
  
  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private dateService: DateService,
    private redirectCleanup: RedirectCleanupService,
    private messageService: MessageService,
    private oidcSecurityService: OidcSecurityService,
    private fakeDataService: FakeDataService){
    }

  ngOnInit(): void {

    if (localStorage.getItem('returnUrl')) {
      setTimeout(() => {
        // localStorage.removeItem('redirect');

        this.redirectCleanup.clearOnce();
      }, 3000); // even 0ms can work, but 100ms is safe
    }

    this.drID = this.route.snapshot.params.id;
    this.selectedDate = this.dateService.getTodayGregorianDateTime();
    this.todayDate = this.dateService.getTodayPersianDate();
    this.todayDateGregorian = this.dateService.getTodayGregorianDateTime();
    this.getDoctorDetails();

    this.getDate();
    this.getVisitsList(this.calendar[0].dayEnum);
    this.getTakenVisited();
    this.getDrException();
    // this.filterAvailableTimes();

    // this.oidcSecurityService.isAuthenticated().subscribe((isAuthenticated)=> {
    //    this.isAuthenticated = isAuthenticated
    //    console.log(this.isAuthenticated);
       
    // });
    
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      this.isAuthenticated = isAuthenticated;
      // console.log('User is authenticated:', isAuthenticated);
    });
    
  }

  takeVisit() {

    if(!this.isAuthenticated){
      // this.messageService.add({severity: 'error', summary: 'خطا', detail: 'لطفا برای دریافت یک نوبت ابتدا در سایت وارد شوید' });
      this.modal.open();
      return false
    }
    if(this.addVisit.startVisit==0 && this.addVisit.visitType!=this.visitType.TextVisit){
      this.messageService.add({severity: 'error', summary: 'خطا', detail: 'برای دریافت نوبت ابتدا زمان مورد نظر را انتخاب کنید' });

      return false
    } else if (this.isExceptedDate() && this.addVisit.visitType==this.visitType.TextVisit){
      this.messageService.add({severity: 'error', summary: 'خطا', detail: 'در این تاریخ نوبت خالی موجود نمی باشد ' });

      return false
    }
    this.selectedDate = this.selectedDate.replace(/ /g,"T");

    this.addVisit = {
      doctorId: Number(this.drID),
      visitType: this.addVisit.visitType,
      date: this.convertToUTC(this.selectedDate),
      startVisit: this.processDateAndTime(this.selectedDate, this.addVisit.startVisit),
      endVisit: this.addVisit.startVisit+this.addVisit.counter,
      counter: this.addVisit.counter
    }
    console.log(this.addVisit.startVisit, this.addVisit);
    

    this.apiService.apiCall('post', '/api/PatientsVisitActive/AddVisit', this.addVisit).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.router.navigate(['/visit-detail/'+res.body.id])
      } else {
      }
    })
  }

  convertToUTC(dateString: string): string {
    const date = new Date(dateString); // Parse the local time string into a Date object
    const utcDate = new Date(date.toISOString()); // Convert to UTC

    console.log(utcDate.toISOString());
    
  
    // Format the UTC date as ISO string for easy output
    return utcDate.toISOString();
  }

  processDateAndTime(dateString: string, startTime: number): number {
    
    
    // Parse the given date
    const date = new Date(dateString);
  
    // Reset hours and minutes to 00:00
    date.setHours(0, 0, 0, 0);
  
    // Convert startTime (minutes) to hours and minutes
    const startHours = Math.floor(startTime / 60);
    const startMinutes = startTime % 60;
  
    // Attach startTime to the date
    date.setHours(startHours, startMinutes, 0, 0);
  
    // Convert to UTC time
    const utcDate = new Date(date.toUTCString());
  
    // Convert UTC time to minutes from 00:00 UTC
    const utcMinutes = utcDate.getUTCHours() * 60 + utcDate.getUTCMinutes();
  
    return utcMinutes
  }

  login() {
    localStorage.setItem('returnUrl', '/doctor-detail/'+this.drID);
    this.oidcSecurityService.authorize(undefined, {
      customParams: {
        requestCulture: 'fa-IR'
      }
    });
  }

  onTimeSelect(selectedTime: string): void {
    this.selectedMinutes = this.realTimes[selectedTime] || null;
    this.addVisit.startVisit = this.selectedMinutes;
  }

  getDoctorDetails() {

    // this.http.get('../../../../../assets/json/drDetails-sample.json').subscribe((res: IDoctor) => {
      
    //   this.drDetail = res;
    // })

    this.apiService.apiCall('get', '/api/SiteDoctors/'+ this.drID +'/DoctorDetailsById').subscribe((res: any) => {
      console.log(res);
      
      if(res.body.model != null){
        this.drDetail = res.body.model;
      }
    })
  }

  filterAvailableTimes(): void {
    // Get current time in minutes (e.g., 13:00 → 780)
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
  
    this.filteredTimeList = this.timeList.filter((time) => {
      const [hours, minutes] = time.split(':').map(Number);
      const timeInMinutes = hours * 60 + minutes;
  
      this.realTimes[time] = timeInMinutes; // Store mapping
  
      if (timeInMinutes < currentMinutes) {
        this.disabledTimes.push(time); // If it's past, add to disabled list
        return false; // Remove from available times
      }
      return true; // Keep future times
    });
  
    console.log('Filtered Available Times:', this.filteredTimeList);
    console.log('Disabled Times:', this.disabledTimes);
  }

  getTakenVisited() {
    // this.selectedDate = this.selectedDate.replace(/ /g,"T");
    this.apiService.apiCall('get', '/api/SiteDoctors/'+ this.drID +'/'+ this.selectedDate +'/GetDoctorVisitScheduleByDate').subscribe((res: any) => {

      console.log('||||||||||||', res);
        this.disabledTimes = [];

      if (res.body.model != null ) {
      
      this.takenVisits = res.body.model;
      
      this.takenVisits.forEach(element => {
        // Convert UTC minutes to local time
        const utcDate = new Date();
        utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
        utcDate.setUTCMinutes(element.startVisit); // Apply UTC minutes
    
        // Get local hours and minutes
        const localHours = utcDate.getHours();
        const localMinutes = utcDate.getMinutes();
    
        // Format the time as HH:mm
        const timeString = `${String(localHours).padStart(2, '0')}:${String(localMinutes).padStart(2, '0')}`;
    
        // Store the converted local time in disabledTimes
        this.disabledTimes.push(timeString);
    });
      // console.log(this.disabledTimes);
      } else {
      } 
    })
    
  }

  getDrException() {
    this.apiService.apiCall('get', '/api/SiteDoctors/'+ this.drID +'/GetAllExceptionsById').subscribe((res: any) => {
      console.log('+++++++',res);
      
      if(res.body.model != null){
        this.exceptionDays = res.body.model;
      }
    })
  }

  getDate() {
    // this.fakeDataService.getDates().subscribe((res: any) => {
    //   this.calendar = res;
    // })

    this.calendar = this.dateService.getPersianDatesWithDetails()
    // console.log(this.calendar);
    
  }

  getVisitsList(dayEnum) {
    this.isVideo = true;
    this.apiService.apiCall('get', '/api/SiteDoctors/'+ this.drID +'/' + dayEnum + '/GetVisitTypeAndPriceById').subscribe((res: any) => {
      console.log('?????????',res);
      
      if (res.body.model != null ) {
        this.visitTypeAndPrice = res.body.model;


        if (this.visitTypeAndPrice.videoVisit!=null){
          this.generateTimeList(this.visitTypeAndPrice.videoVisit?.start, this.visitTypeAndPrice.videoVisit.end, this.visitTypeAndPrice.videoVisit.duration);
          this.addVisit.visitType=this.visitType.VideoVisit;
          this.addVisit.counter=this.visitTypeAndPrice.videoVisit.duration;
          // return false;
        } 
        else if (this.visitTypeAndPrice.voiceVisit!=null||this.visitTypeAndPrice.voiceVisit?.start!=0) {
          this.generateTimeList(this.visitTypeAndPrice.voiceVisit?.start, this.visitTypeAndPrice.voiceVisit.end, this.visitTypeAndPrice.voiceVisit.duration);
          this.addVisit.visitType=this.visitType.PhoneVisit;
          this.addVisit.counter=this.visitTypeAndPrice.voiceVisit.duration;
          // return false;
        } else if (this.visitTypeAndPrice.voiceVisit!=null||this.visitTypeAndPrice.voiceVisit?.start!=0) {
          this.generateTimeList(0, 0, 0);
          this.addVisit.visitType=this.visitType.TextVisit;
          this.addVisit.counter=this.visitTypeAndPrice.textVisit.duration;
          // return false;
        } else if (this.visitTypeAndPrice.visit!=null||this.visitTypeAndPrice.visit?.start!=0) {
          this.generateTimeList(this.visitTypeAndPrice.visit?.start, this.visitTypeAndPrice.visit.end, this.visitTypeAndPrice.visit.duration);
          this.addVisit.visitType=this.visitType.BodyVisit;
          this.addVisit.counter=this.visitTypeAndPrice.visit.duration;
          // return false;
        }
      }
      // this.generateTimeList(720, 840, 15);
    })
  }

  isExceptedDate():boolean {
    // this.exceptionDays.forEach(element => {
    //   if (this.selectedDate.slice(0,10) == element.exception.slice(0,10)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // });

    if (this.exceptionDays != null) {
      return this.exceptionDays.some(element => 
        this.selectedDate.slice(0, 10) === element.exception.slice(0, 10)
      );
    } else {
      return false;
    }

    
  }

  generateTimeList(start, end, duration) {    

    this.addVisit.counter = duration

    if (this.selectedDate == this.todayDateGregorian) {

      this.timeList = [];
      const now = new Date();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();
      for (let current = start; current < end; current += duration) {
        // for (let current = this.visitTypeAndPrice.textVisit?.start; current < this.visitTypeAndPrice.textVisit.end; current += 15) {
        const hours = Math.floor(current / 60);
        const minutes = current % 60;
        // Format the time as HH:mm
        const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        //  console.log(currentMinutes, current);
        if (currentMinutes < current) {
          
          this.timeList.push(timeString);
        } else {
          // this.timeList.push(timeString);
        }
        
      }

      this.timeList.forEach((time) => {
        const [hours, minutes] = time.split(':').map(Number);
        this.realTimes[time] = hours * 60 + minutes; // Convert to minutes
      });

      // this.getTakenVisited();      
      return this.timeList;

    } else {
      this.timeList = [];
      
      for (let current = start; current < end; current += duration) {
        // for (let current = this.visitTypeAndPrice.textVisit?.start; current < this.visitTypeAndPrice.textVisit.end; current += 15) {
        const hours = Math.floor(current / 60);
        const minutes = current % 60;
        // Format the time as HH:mm
        const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        this.timeList.push(timeString);
      }

      this.timeList.forEach((time) => {
        const [hours, minutes] = time.split(':').map(Number);
        this.realTimes[time] = hours * 60 + minutes; // Convert to minutes
      });

      // this.getTakenVisited();
      return this.timeList;
    }

  }

  isDisabled(time: string): boolean {
    return this.disabledTimes.includes(time);
  }
  

  // generateTimeList(start, end, duration) {
  //   const timeList = [];
    
  //   for (let current = start; current < end; current += duration) {
  //     const hours = Math.floor(current / 60);
  //     const minutes = current % 60;
  //     // Format the time as HH:mm
  //     const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  //     timeList.push(timeString);
  //   }
    
  //   return timeList;
  // }
  
  // Example usage
  // const start = 540; // 09:00 in minutes
  // const end = 600;   // 10:00 in minutes
  // const duration = 15;
  
  // const timeList = generateTimeList(start, end, duration);
  // console.log(timeList); // Output: [ '09:00', '09:15', '09:30', '09:45' ]
  




  // Update the carousel position
  itemsPerPage: number = 5;
  currentIndex: number = 0;

  get totalPages(): number {
    return Math.ceil(this.calendar.length!=0?this.calendar.length / this.itemsPerPage:null);
  }

  updateCarousel(indexChange: number): void {
    const newIndex = this.currentIndex + indexChange;
    if (newIndex >= 0 && newIndex < this.totalPages) {
      this.currentIndex = newIndex;
    }

  }
}
